/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { ReactElement } from 'react';
import './MatchedVisasSideBarItem-Desktop.scss';
import FlagSwitcher from '../../flagSwitcher';

type MatchedVisasSideBarItemProps = {
    countryVisaData: any;
    isAssessmentScoreEmpty?: boolean;
};

function MatchedVisasSideBarItemDesktop({
    countryVisaData,
    isAssessmentScoreEmpty,
}: MatchedVisasSideBarItemProps): ReactElement | null {
    const trueScore = (item: any): number => {
        const score: number = Math.round((100 * item.summary.score) / item.summary.max_score);

        if (isNaN(score)) {
            return 70;
        }
        return score;
    };
    const scoreLevel = (score: number) =>
        score < 50 ? 'lowScore' : score < 71 ? 'mediumScore' : 'highScore';

    const sortedItems = [...countryVisaData.eligible_programs].sort((a, b) => {
        if (trueScore(a) < trueScore(b)) {
            return 1;
        } else if (trueScore(a) > trueScore(b)) {
            return -1;
        } else {
            return 0;
        }
    });

    return (
        <div className={'MatchedVisasSideBarItemWrapper'}>
            <div className={'countryWrapper'}>
                <div className={'countryFlag'}>
                    <FlagSwitcher country={countryVisaData.country} />
                </div>
                <div className={'countryName'}>{countryVisaData.country}</div>
            </div>
            <div className={`MatchedVisasSideBarItemResults notFilled`}>
                {sortedItems.slice(0, 3).map((item: any) => (
                    <div className={'MatchedVisasSideBarItemResult'} key={item.program_name}>
                        <div className={'visaResultTitle'}>{item.program_type}</div>
                        <div className={'visaResultBody'}>
                            <div className={'visaResultText'}>
                                {item.program_name.split(' - Subclass')[0]}
                            </div>
                            <div className={`visaResultScore ${scoreLevel(trueScore(item))}`}>
                                {`${trueScore(item)}%`}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MatchedVisasSideBarItemDesktop;
